import { ResponseSuccess } from '../../../../../shared/types';
import api from '../../../../../api';
import { OutcomeCategory } from '../../../enums/custom-outcome';
import { PaginationQueryParams } from '../../../../../shared/types/request';
import {
  CreateCallOutcomePayload,
  UpdateCallOutcomePayload,
} from '../types';

const BASE_URL = '/dialer/call-outcome';

// List call outcomes with pagination (for settings page)
export const getCallOutcomesWithPagination = async (
  params: PaginationQueryParams & { search?: string; category?: string },
) =>
  api.get<ResponseSuccess>(`${BASE_URL}/list`, {
    params,
  });

// List custom call outcomes with pagination
export const getCustomCallOutcomes = async (
  params: PaginationQueryParams & { search?: string } = {},
) =>
  api.get<ResponseSuccess>(`${BASE_URL}/list`, {
    params: { ...params, category: OutcomeCategory.Custom },
  });

// List default (system) call outcomes with pagination
export const getDefaultCallOutcomes = async (
  params: PaginationQueryParams & { search?: string } = {},
) =>
  api.get<ResponseSuccess>(`${BASE_URL}/list`, {
    params: { ...params, category: OutcomeCategory.Default },
  });

// List all call outcomes (no pagination — for delete modal dropdown)
export const getAllCallOutcomes = async () =>
  api.get<ResponseSuccess>(`${BASE_URL}/list`);

// Create custom call outcome
export const createCallOutcome = async (payload: CreateCallOutcomePayload) =>
  api.post<ResponseSuccess>(`${BASE_URL}/create`, payload);

// Update call outcome
export const updateCallOutcome = async (
  callOutcomeId: number,
  payload: UpdateCallOutcomePayload,
) => api.patch<ResponseSuccess>(`${BASE_URL}/${callOutcomeId}`, payload);

// Delete call outcome
export const deleteCallOutcome = async (
  callOutcomeId: number,
  replacementCallOutcomeId: number,
) =>
  api.delete<ResponseSuccess>(
    `${BASE_URL}/${callOutcomeId}?replacementCallOutcomeId=${replacementCallOutcomeId}`,
  );
